<template>
  <div class="border-t bg-white overflow-auto py-4 rounded shadow h-full">
    <div class="font-semibold text-l mx-4 mb-4 text-gray-500">Avg Dwell time</div>
    <div class="px-2">
      <canvas id="dwell_time" class=""></canvas>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import GraphQl from "../../services/graphql.service";
import moment from 'moment'

export default {
  name: "DwellTime",
  props: {
    filters: Object
  },
  data() {
    return {
      planetChartData: {
        data: {
          datasets: [
            {
              label: "Dwell time (avg)",
              type: 'line',
              fill: true,
              backgroundColor: 'rgba(178,245,234,0.5)',
              showLines: true,
              borderColor: '#38B2AC',
              lineTension: .5,
              borderWidth: 1,
              data: []
            }
          ]
        },
        options: {
          legend: {
            display: false,
            labels: {
              fontColor: 'teal'
            }
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                min: 0
              },
              scaleLabel: {
                display: true,
                labelString: "Duration (Hr)"
              }
            }],
            xAxes: [{
              type: "time",
              time: {
                unit: "hour"
              },
              distribution: 'linear'
            }],
          }
        }
      },
    }
  },
  mounted() {
    this.loadStats();
  },
  watch: {
    filters: {
      handler: function () {
        this.loadStats();
      },
      deep: true
    }
  },
  methods: {
    loadStats() {
      this.planetChartData.data.datasets[0].label = [];
      this.planetChartData.data.datasets[0].data = [];

      let v = [];
      this.filters.venues.forEach(function (venue) {
        v.push(venue.id);
      });
      let params = (this.filters.venues.length > 0 ? 'venues:["' + v.join('","') + '"],' : '') +
          'startDate: "' + this.filters.dateRange.startDate + '", ' +
          'endDate: "' + this.filters.dateRange.endDate + '"';
      GraphQl.sendRequest('{organization(id:"' + this.$store.getters.orgId + '") {dwellTime(' + params + '){dwell_time, time}}}', this.filters)
          .then(response => {
            response.organization.dwellTime.forEach((stat) => {
              this.planetChartData.data.datasets[0].data.push({
                t: moment(stat.time, 'YYYY-MM-DD HH').valueOf(),
                y: stat.dwell_time != null ? parseFloat(stat.dwell_time / 3600) : 0
              });
            });
            new Chart(document.getElementById("dwell_time"), {
              type: 'line',
              data: this.planetChartData.data,
              options: this.planetChartData.options,
            });
          })
    }
  }
}
</script>

<style scoped>

</style>